const initialState = {
    mainSlider: [],
    adsTwoImages: [],
    adsFourImages: [],
    tasteful1: [],
    tasteful2: [],
    bestSelling: [],
    hotSales: [],
    featuredDiscounts: [],
    amazingOffers: [],
    stories: [],
    sellers: [],
};

const main = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_MAIN':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default main;
